import { LDContext } from "launchdarkly-react-client-sdk";

export type AnonymousContext = { anonymous: true };

export type UserContext =
  { key: string; name?: string; email?: string } | AnonymousContext;

// The SDK strips undefined-valued keys from stored contexts, so keeping them
// would fail every stored-vs-desired comparison.
export const buildContext = (user: UserContext): LDContext =>
  Object.fromEntries(
    Object.entries({ kind: "user", ...user }).filter(
      ([, value]) => value !== undefined,
    ),
  ) as LDContext;

export const ANONYMOUS_CONTEXT: AnonymousContext = { anonymous: true };

export const INITIAL_CONTEXT: LDContext = buildContext(ANONYMOUS_CONTEXT);

export const clientSideID: string | undefined = import.meta.env
  .VITE_LAUNCH_DARKLY_CLIENT_ID;
